type Storage = {
    get(): string | null;
    set(value: string | null): void;
    clear(): void;
};

export function makeLocalStorage(key: string): Storage {
    return {
        get: () => {
            try {
                return typeof window !== "undefined" ? localStorage.getItem(key) : null;
            } catch {
                return null;
            }
        },
        set: (v) => {
            try {
                if (typeof window === "undefined") return;
                if (v) {
                    localStorage.setItem(key, v);
                } else {
                    localStorage.removeItem(key);
                }
            } catch {
                /* ignore */
            }
        },
        clear: () => {
            try {
                if (typeof window !== "undefined") localStorage.removeItem(key);
            } catch {
                /* ignore */
            }
        },
    };
}
